import React, { useEffect, useState } from "react";
import { BASE_URL,BASE_IMAGE_URL, PAGING_SIZE_DEFAULT } from "../../service/apiConfig";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Row,
  Col,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  Divider,
  Tag
} from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import roleApi from "../../service/roleService";
import locationTourApi from "../../service/locationTourService";
import  userService from "../../service/userService";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "./management.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Role } from "../../components/shares/roles";
const { Option } = Select;
export default function ManagementPage() {
  const navigate = useNavigate();

  const currentLocation = useSelector((state) => state.currentLocation);
  const [currentId, serCurrentId] = useState(0);
  const [listAdmin, setListAdmin] = useState([]);
  const [listRole, setListRole] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const adminAuthen = useSelector((state) => state.adminAuthen);

  console.log(currentLocation);
  // const { id } = useParams();
  const [form] = Form.useForm();

  useEffect(() => {
    const userData = adminAuthen.user
    if(userData?.role != Role.SuperAdmin ){
      navigate("/management");
    }
    serCurrentId(userData?.id)
    getAllUser();
  }, []);

  const getAllUser = () => {
    const body = {      
      page: 1,
      pageSize: PAGING_SIZE_DEFAULT
    };
    userService.getAllUser(body).then((res) => {
      setListAdmin(res.data);
    });
  };

  

  const lockUser = () => {
    // adminService.adminApi.deleteAdmin(adminId).then((res) => {
    //   notification.success({ message: `Delete Admin success` });
    //   getAllAdmin();
    //   setOpenDeleteDialog(false);
    // });
  };

  const getRole = () => {
    roleApi.getAllRole().then((response) => {
      setListRole(response.data);
      console.log(333, response.data);
      form.setFieldsValue({ roleId: response.data[0].id });
    });
  };

  const layout = {
    labelCol: { span: 8 },
    labelAlign: "left",
    wrapperCol: { span: 16 },
  };
  const columnsTour = [
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Trạng thái",      
      key: "status",
      render: (_, record) => (
        <Space size="middle">
          <Tag
            type="primary"
            style={{
              borderRadius: 8,
            }}            
          >
          {_.locked === true ?  'Đang khóa' : 'Đang hoạt động'}
          </Tag>          
        </Space>
      ),      
    },
    {
      title: "Thiết bị đăng nhập",
      dataIndex: "platform",
      key: "platform",
    },
    // ,        
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Space size="middle">        
    //       <Button
    //         type={ _.locked === true ? 'primary':  'danger'}
    //         style={{
    //           borderRadius: 8,
    //         }}
    //         onClick={() => openDeleteTour(_.id)}
    //       >
    //         {_.locked === true ? 'Mở tài khoản' : 'Khóa tài khoản'}
    //       </Button>
    //     </Space>
    //   ),
    // },
  ];
  const openDeleteTour = (id) => {
    setOpenDeleteDialog(true);
  };


  let _contentState = ContentState.createFromText("Sample content state");
  const raw = convertToRaw(_contentState);
  const [contentState, setContentState] = useState(raw);
  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Người sử dụng
          </Typography>
        }        
        extra={
          <Typography style={{ textAlign: "center" }}>
             Tổng số : {listAdmin?.length}
          </Typography>
        }
      >
        <Table columns={columnsTour} dataSource={listAdmin} bordered />                          
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={lockUser}
        onCancel={() => {
          setOpenDeleteDialog(false);
        }}
        title={`Khóa tài khoản người sử dụng?`}
      >
        Bạn đang muốn khóa tài khoản của người sử dụng này. Bạn có chắc không?
      </Modal>
    </>
  );
}
